import React, { useContext, useEffect, useState } from "react";
import {
  Box,
  ButtonStyled,
  HeadingStyled,
  SpanStyled,
} from "../../../../components/styled/Elements";
import ViewPage from "../../../../components/common/pageView/pageView";
import { t } from "i18next";
import styled from "styled-components";
import {
  BackArrow,
  LocationPin,
} from "../../../../components/styled/AllImages";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { formateAmounts, requireAuthNavigate } from "../../../../utils";
import GalleryModal from "../../../../components/common/Modal/galleryModal/GalleryModal";
import {
  imageGalleryData,
  videoGalleryData,
} from "../../../../helpers/dummyConstants";
import PropertiesApi from "../../../../services/api/propertiesApi";
import { Col, Placeholder } from "react-bootstrap";
import { ThemeLoader } from "../../../../components/styled/CustomElements";
import VisitScheduleModal from "../../../../components/auth/Modal/ScheduleVisitModal";
import { AuthContext } from "../../../../context/authContext";

const data = {
  listingType: "For Sale",
  propertyType: "Apartment",
  price: "13430000",
  propertyStatus: "Ready",
  advertisingLicense: "FAL987465123",
  description:
    "This modern 2-bedroom apartment offers a bright and spacious living area, a fully equipped kitchen, and a private balcony with city views. Located in a secure building with elevator access, the unit also includes central air conditioning, built-in wardrobes, and covered parking. Ideal for small families or professionals seeking comfort and convenience in a prime location.",
};

const PropertyDetails = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { isAuthenticated } = useContext(AuthContext);
  const {
    i18n: { language },
  } = useTranslation();
  const { id, username } = useParams();

  const [showModal, setShowModal] = useState(false);
  const [showScheduleModal, setScheduleShowModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [propertyData, setPropertyData] = useState();
  const [galleryType, setGalleryType] = useState("exterior_images");

  const handleCloseModal = () => {
    setShowModal(false);
  };

  const getCurrentGalleryData = () => {
    return propertyData && galleryType === "interior_videos"
      ? propertyData?.media?.interior_videos
      : galleryType === "exterior_videos"
      ? propertyData?.media?.exterior_videos
      : galleryType === "interior_images"
      ? propertyData?.media?.interior_images
      : propertyData?.media?.exterior_images;
  };

  const getPropertyDetails = async () => {
    setLoading(true);
    try {
      const { data, code } = await PropertiesApi.getSingleProperty(id);
      if (code === 200 && data) {
        setPropertyData(data);
      }
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getPropertyDetails();
  }, [language]);

  return (
    <Wrapper>
      <MainCard>
        {loading ? (
          <ThemeLoader />
        ) : (
          <>
            <Box className="d-flex justify-content-between mb-3 gap-3 flex-wrap">
              <Box className="d-flex gap-1 gap-md-2">
                <BackArrow
                  onClick={() => {
                    if (location.pathname.includes("visitor-listing")) {
                      navigate(`/profile/${username}`);
                    } else navigate("/my-profile");
                  }}
                  style={{
                    transform: language === "ar" ? "scale(-1)" : "scale(1)",
                    cursor: "pointer",
                  }}
                />
                <Box>
                  <HeadingStyled>{`${t(
                    Number(propertyData?.listing_property_type?.id) === 7
                      ? language === "en"
                        ? propertyData?.listing_property_type
                            ?.other_prop_type_en
                        : propertyData?.listing_property_type
                            ?.other_prop_type_ar
                      : propertyData?.listing_property_type?.name
                  )} ${t("for")} ${
                    propertyData?.listing_type?.name
                  }`}</HeadingStyled>
                  <Box className="mt-1 d-flex gap-1">
                    <SpanStyled
                      size="14px"
                      color="var(--lightGrey)"
                      className="d-flex align-items-center gap-1"
                    >
                      <Box>
                        <LocationPin />
                      </Box>{" "}
                      {propertyData?.city}
                      {" |"}
                      {/* Replace with actual city name */}
                    </SpanStyled>
                    <SpanStyled size="14px" color="var(--lightGrey)">
                      {language === "en"
                        ? propertyData?.neighborhood_data?.name_en
                        : propertyData?.neighborhood_data?.name_ar}
                    </SpanStyled>
                  </Box>
                </Box>
              </Box>
              <Col md={5}>
                <Box className="d-flex align-items-center justify-content-between">
                  <HeadingStyled className="px-sm-0 px-4">
                    {formateAmounts(propertyData?.price)} {t("sar")}
                  </HeadingStyled>
                  {location.pathname.includes("visitor-listing") && (
                    <ButtonStyled
                      label={t("schedule_visit")}
                      bg="var(--themeColorSecondary)"
                      onClick={() => {
                        if (
                          !requireAuthNavigate(
                            navigate,
                            isAuthenticated,
                            `${location.pathname}${location.search}`
                          )
                        ) {
                          return;
                        }
                        setScheduleShowModal(true);
                      }}
                    />
                  )}
                </Box>
              </Col>
            </Box>
            <Card className="mb-3">
              <HeadingStyled className="mx-4">
                {t("property_details")}
              </HeadingStyled>
              <Box>
                <ViewPage
                  label={t("listing_type")}
                  text={propertyData?.listing_type?.name}
                  // render={view.render ? view.render : null}
                />
                <ViewPage
                  label={t("property_type")}
                  text={propertyData?.listing_property_type?.name}
                  // render={view.render ? view.render : null}
                />
                {Number(propertyData?.listing_property_type?.id) === 7 && (
                  <>
                    <ViewPage
                      label={t("Other")}
                      text={
                        language === "en"
                          ? propertyData?.listing_property_type
                              ?.other_prop_type_en
                          : propertyData?.listing_property_type
                              ?.other_prop_type_ar
                      }
                      // render={view.render ? view.render : null}
                    />
                  </>
                )}
                <ViewPage
                  label={t("property_status")}
                  text={propertyData?.property_status?.name}
                  // render={view.render ? view.render : null}
                />
                <ViewPage
                  label={t("advertising_license")}
                  text={propertyData?.ad_number}
                  // render={view.render ? view.render : null}
                />
                {propertyData?.contact_phone && (
                  <ViewPage
                    label={t("confirm_contact_number")}
                    text={propertyData.contact_phone}
                  />
                )}
                <ViewPage
                  label={t("Description")}
                  text={
                    language === "en"
                      ? propertyData?.description_en
                      : propertyData?.description_ar
                  }
                  render={() => (
                    <SpanStyled
                      color="var(--text)"
                      style={{ whiteSpace: "pre-wrap" }}
                    >
                      {language === "en"
                        ? propertyData?.description_en
                        : propertyData?.description_ar}
                    </SpanStyled>
                  )}
                />
              </Box>
            </Card>

            <Card>
              <HeadingStyled className="mx-4">
                {t("property_image_video")}
              </HeadingStyled>

              <ViewPage
                label={t("exterior_images")}
                text={"btn"}
                render={() =>
                  propertyData?.media?.exterior_images?.length > 0 ? (
                    <ButtonStyled
                      bg="var(--themeColorSecondary)"
                      label={t("view_image_gallery")}
                      onClick={() => {
                        setGalleryType("exterior_images");
                        setShowModal(true);
                      }}
                    />
                  ) : (
                    "N/A"
                  )
                }
              />
              <ViewPage
                label={t("interior_images")}
                text={"btn"}
                render={() =>
                  propertyData?.media?.interior_images?.length > 0 ? (
                    <ButtonStyled
                      bg="var(--themeColorSecondary)"
                      label={t("view_image_gallery")}
                      onClick={() => {
                        setGalleryType("interior_images");
                        setShowModal(true);
                      }}
                    />
                  ) : (
                    "N/A"
                  )
                }
              />
              <ViewPage
                label={t("exterior_videos")}
                text={"btn"}
                render={() =>
                  propertyData?.media?.exterior_videos?.length > 0 ? (
                    <ButtonStyled
                      bg="var(--themeColorSecondary)"
                      label={t("view_video_gallery")}
                      onClick={() => {
                        setGalleryType("exterior_videos");
                        setShowModal(true);
                      }}
                    />
                  ) : (
                    "N/A"
                  )
                }
              />
              <ViewPage
                label={t("interior_videos")}
                text={"btn"}
                render={() =>
                  propertyData?.media?.interior_videos?.length > 0 ? (
                    <ButtonStyled
                      bg="var(--themeColorSecondary)"
                      label={t("view_video_gallery")}
                      onClick={() => {
                        setGalleryType("interior_videos");
                        setShowModal(true);
                      }}
                    />
                  ) : (
                    "N/A"
                  )
                }
              />
            </Card>
          </>
        )}
      </MainCard>

      <GalleryModal
        show={showModal}
        onHide={handleCloseModal}
        type={galleryType}
        items={getCurrentGalleryData()}
      />
      <VisitScheduleModal
        show={showScheduleModal}
        onHide={() => setScheduleShowModal(false)}
        listingRef={propertyData?.id ?? id}
      />
    </Wrapper>
  );
};

export default PropertyDetails;
const Wrapper = styled.div`
  padding: 20px 30px;
  max-width: 1071px;
  margin: 0 auto;
`;

const MainCard = styled.div`
  background: #fff;
  border-radius: 10px;
  padding: 25px;

  @media (max-width: 767px) {
    padding: 0;
    background: none;
  }
`;
const Card = styled.div`
  background: #fff;
  border-radius: 12px;
  box-shadow: 0px 1px 3px 0px #00000008;
  box-shadow: 0px 5px 5px 0px #00000008;
  box-shadow: 0px 12px 7px 0px #00000005;
  box-shadow: 0px 22px 9px 0px #00000000;
  box-shadow: 0px 34px 9px 0px #00000000;
  border: 1px solid #dee8f4;
  padding-top: 20px;
  padding-bottom: 20px;
`;
